var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["value", "onChange", "error", "name", "elements", "columns", "disabled", "disableCheckboxSelection", "disableDetailsPanel", "disableBorder", "resetOnUnmount", "apiKey", "apiRequest", "getListData", "variant", "cellStyles", "sx"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { CheckBox, CheckBoxOutlineBlank, ExpandLess, ExpandMore } from '@mui/icons-material';
import { IconButton, Stack } from '@mui/material';
import { DataGridPremium, GRID_DETAIL_PANEL_TOGGLE_COL_DEF, GRID_DETAIL_PANEL_TOGGLE_FIELD, gridClasses, useGridApiRef } from '@mui/x-data-grid-premium';
import { useCallback, useEffect, useMemo } from 'react';
import { deleteState } from '../../../../redux/crudSlice';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import ExpandedRowDetails from './expandedRowDetails';
export default function FormList(props) {
    var _a, _b, _c;
    var _this = this;
    var _crud$apiKey2;
    var value = props.value, onChange = props.onChange, error = props.error, _d = props.name, name = _d === void 0 ? 'FormList' : _d, _e = props.elements, elements = _e === void 0 ? [] : _e, _f = props.columns, columns = _f === void 0 ? [] : _f, disabled = props.disabled, _g = props.disableCheckboxSelection, disableCheckboxSelection = _g === void 0 ? false : _g, _h = props.disableDetailsPanel, disableDetailsPanel = _h === void 0 ? false : _h, _j = props.disableBorder, disableBorder = _j === void 0 ? false : _j, _k = props.resetOnUnmount, resetOnUnmount = _k === void 0 ? false : _k, _l = props.apiKey, apiKey = _l === void 0 ? name : _l, apiRequest = props.apiRequest, getListData = props.getListData, _m = props.variant, variant = _m === void 0 ? 'compact' : _m, cellStyles = props.cellStyles, sx = props.sx, others = _objectWithoutProperties(props, _excluded);
    var gridApi = useGridApiRef();
    var crud = useAppSelector(function (state) { return state.crud; });
    var dispatch = useAppDispatch();
    useEffect(function () {
        var expandedPanels = gridApi.current.getExpandedDetailPanels();
        if (error !== null && error !== void 0 && error.rowId && !expandedPanels.includes(error === null || error === void 0 ? void 0 : error.rowId)) {
            gridApi.current.setExpandedDetailPanels(__spreadArray(__spreadArray([], expandedPanels, true), [error === null || error === void 0 ? void 0 : error.rowId], false));
        }
    }, [error === null || error === void 0 ? void 0 : error.id]);
    useEffect(function () {
        var _crud$apiKey;
        if (getListData && !((_crud$apiKey = crud[apiKey]) !== null && _crud$apiKey !== void 0 && _crud$apiKey.data))
            getData();
        return function () {
            if (resetOnUnmount)
                dispatch(deleteState({
                    key: apiKey
                }));
        };
    }, [!((_crud$apiKey2 = crud[apiKey]) !== null && _crud$apiKey2 !== void 0 && _crud$apiKey2.data)]);
    var getData = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var _res$data, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (getListData === null || getListData === void 0 ? void 0 : getListData({
                        key: apiKey,
                        request: apiRequest
                    }))];
                case 1:
                    res = _a.sent();
                    if (res !== null && res !== void 0 && (_res$data = res.data) !== null && _res$data !== void 0 && _res$data.length) {
                        onChange === null || onChange === void 0 || onChange(null, res === null || res === void 0 ? void 0 : res.data);
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [apiKey, apiRequest]);
    var memoizedColumns = useMemo(function () {
        var booleanColDef = !disableCheckboxSelection ? [{
                type: 'boolean',
                field: 'Selected',
                width: 30
            }] : [];
        var detailsColDef = !disableDetailsPanel ? [GRID_DETAIL_PANEL_TOGGLE_COL_DEF] : [];
        return __spreadArray(__spreadArray(__spreadArray([], booleanColDef, true), columns, true), detailsColDef, true);
    }, [columns, disableCheckboxSelection, disableDetailsPanel]);
    var updateRow = useCallback(function (e, row) { return __awaiter(_this, void 0, void 0, function () {
        var newRows;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    newRows = value === null || value === void 0 ? void 0 : value.map(function (r) { return r.id === (row === null || row === void 0 ? void 0 : row.id) ? row : r; });
                    return [4 /*yield*/, (onChange === null || onChange === void 0 ? void 0 : onChange(e, newRows))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [value, onChange]);
    var renderDetails = useCallback(function (params) { /*#__PURE__*/ return React.createElement(ExpandedRowDetails, _extends({}, params, {
        disabled: disabled,
        elements: elements,
        updateRow: updateRow,
        errors: params.id === (error === null || error === void 0 ? void 0 : error.rowId) ? error : undefined
    })); }, [elements, error === null || error === void 0 ? void 0 : error.id, value, disabled, updateRow]);
    var onCellClick = useCallback(function (_ref, e) {
        var row = _ref.row, field = _ref.field;
        if (field === 'Selected')
            updateRow(e, _objectSpread(_objectSpread({}, row), {}, {
                Selected: !(row !== null && row !== void 0 && row.Selected)
            }));
    }, [updateRow]);
    var detailPanelExpandedRowIds = useMemo(function () { return variant === 'expanded' ? value === null || value === void 0 ? void 0 : value.map(function (v) { return v.id; }) : undefined; }, [value, variant]);
    return /*#__PURE__*/ React.createElement(Stack, {
        overflow: "hidden"
    }, /*#__PURE__*/ React.createElement(DataGridPremium, _extends({
        apiRef: gridApi,
        columns: memoizedColumns,
        rows: value !== null && value !== void 0 ? value : [],
        hideFooter: true,
        columnHeaderHeight: 0,
        rowHeight: 60,
        disableColumnResize: true,
        disableColumnReorder: true,
        disableColumnMenu: true,
        disableRowSelectionOnClick: true,
        getDetailPanelContent: !(elements !== null && elements !== void 0 && elements.length) ? undefined : renderDetails,
        getDetailPanelHeight: function () { return 'auto'; },
        detailPanelExpandedRowIds: detailPanelExpandedRowIds,
        onCellClick: disableCheckboxSelection ? undefined : onCellClick,
        scrollbarSize: 0,
        loading: crud["isLoading".concat(apiKey)] === 'loading',
        columnVisibilityModel: (_a = {},
            _a[GRID_DETAIL_PANEL_TOGGLE_FIELD] = !disableDetailsPanel,
            _a.Selected = !disableCheckboxSelection,
            _a),
        slots: {
            detailPanelCollapseIcon: ExpandLess,
            detailPanelExpandIcon: ExpandMore,
            booleanCellFalseIcon: function () { /*#__PURE__*/ return React.createElement(IconButton, null, " ", /*#__PURE__*/ React.createElement(CheckBoxOutlineBlank, {
                color: "secondary"
            }), " "); },
            booleanCellTrueIcon: function () { /*#__PURE__*/ return React.createElement(IconButton, null, " ", /*#__PURE__*/ React.createElement(CheckBox, {
                color: "info"
            }), " "); },
            columnHeaders: function () { return null; }
        },
        slotProps: {
            loadingOverlay: {
                variant: 'circular-progress',
                noRowsVariant: 'skeleton'
            }
        },
        getRowSpacing: variant !== 'compact' ? function (_ref2) {
            var isFirstVisible = _ref2.isFirstVisible;
            return {
                top: isFirstVisible ? undefined : 16
            };
        } : undefined,
        localeText: {
            noRowsLabel: 'No records found'
        }
    }, others, {
        sx: _objectSpread(_objectSpread(_objectSpread((_b = {
                borderRadius: 2,
                borderColor: disableBorder ? 'transparent' : undefined,
                fontSize: 'inherit',
                overflow: 'hidden'
            },
            _b["& .".concat(gridClasses.virtualScroller)] = {
                minHeight: 50
            },
            _b["& .".concat(gridClasses.virtualScrollerRenderZone)] = {
                overflow: 'hidden'
            },
            _b["& .".concat(gridClasses.overlay)] = {
                color: 'text.tertiary'
            },
            _b["& .".concat(gridClasses.cell)] = _objectSpread({
                ':focus': {
                    outline: 'none'
                },
                ':focus-within': {
                    outline: 'none'
                },
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                borderTop: variant !== 'compact' ? 0 : undefined
            }, cellStyles),
            _b[".".concat(gridClasses.detailPanel)] = {
                background: 'none'
            },
            _b), variant === 'comfortable' ? (_c = {
                border: 0,
                borderRadius: 0
            },
            _c["& .".concat(gridClasses.row)] = {
                border: '1px solid ',
                borderColor: 'secondary.200',
                borderRadius: 2
            },
            _c["& .".concat(gridClasses['row--detailPanelExpanded'])] = {
                borderBottom: 0,
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0
            },
            _c["& .".concat(gridClasses.detailPanel)] = {
                border: '1px solid',
                borderColor: 'secondary.200',
                borderRadius: 2,
                borderTop: 0,
                borderTopLeftRadius: 0,
                borderTopRightRadius: 0,
                p: 2
            },
            _c) : undefined), variant === 'expanded' ? {
            border: 0,
            borderRadius: 0
        } : undefined), sx)
    })));
}
